// @ts-nocheck

import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card, IconButton, MenuItem, Select, FormControl } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table from "../../components/tables/table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SoftButton from "../../components/common/softButton";
import { toast } from "react-toastify";
import { deleteLocalization, getLocalization } from "../../features/localization";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import ActionMenu from "../../components/common/custom/action-menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const LocalizationManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { localizations, status,total } = useSelector((state: any) => state.localization);
// console.log(localizations,'localizations')
  const [language, setLanguage] = useState("en");
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleDelete = (id: string) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this localization?"
    );
    if (isConfirmed) {
      dispatch(deleteLocalization(id))
        .then((res) => {
          toast.success(res.payload.message || "Localization deleted successfully.");
          dispatch(getLocalization({ page: pageIndex, limit: pageSize, lan: language }));
        })
        .catch((err) => {
          console.error(err);
          toast.error("Failed to delete localization.");
        });
    }
  };

  const columns = [
    {
      header: "Language",
      accessorKey: "language",
      id: "language",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()}</strong>,
    },
    {
      header: "Key",
      accessorKey: "key",
      id: "key",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Value",
      accessorKey: "value",
      id: "value",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id =  info.row.original._id ; 
        return (
          <ActionMenu>
            <MenuItem onClick={() => navigate(`/localization/edit/${id}`)}>
              Edit
            </MenuItem>
            {/* <MenuItem onClick={() => handleDelete(id)}>Delete</MenuItem> */}
          </ActionMenu>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getLocalization({ page: pageIndex, limit: pageSize, lan: language }));
  }, [dispatch, pageIndex, pageSize, language]);

  useEffect(() => {
    if (status && localizations ) {
      setData(localizations);
      setTotalRows(total || 0);
    }
  }, [status, localizations]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
                Localization Management
              </SoftTypography>

              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  width: "30%",
                }}
              >
                <FormControl
                  sx={{
                    minWidth: 80,
                    marginRight: 2,
                    minWidth: "160px",
                  }}
                  size="small"
                >
                  <Select
                    id="language"
                    name="language"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
                  >
                    <MenuItem value={"en"} sx={{ marginBottom: "5px" }}>
                      English
                    </MenuItem>
                    <MenuItem value={"ar"}>Arabic</MenuItem>
                  </Select>
                </FormControl>
                <SoftButton
                  onClick={() => navigate("/localization/add")}
                  variant="contained"
                  color="final"
                  style={{ textTransform: "Capitalize" }}
                >
                  Add Localization
                </SoftButton>
              </SoftBox>
            </SoftBox>
            <Table
              columns={columns}
              data={data}
              pageIndex={pageIndex}
              pageSize={pageSize}
              totalRows={totalRows}
              onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            />
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default LocalizationManagement;
